import React from 'react'

import styles from './styles.module.less'

const Empty = ({ title, children }) => {
  return (
    <div className={styles.empty}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.details}>{children}</div>
    </div>
  )
}

export default Empty
